import { RP_TEMPLATES } from '@Web/Pages/Web/Home/constants.jsx';
import SectionHeader from '@Web/Src/Components/SectionHeader';
import Loading from '@Web/Src/UI/Loading';

const ReferralProgramsTemplatesLazy = () => {
    return (
        <div className='mt-40 w-full'>
            <SectionHeader
                icon='code-file'
                title={__('Access referral program templates for every type of business')}
                desc={
                    <>
                        {__(
                            'Get access to hundreds of referral program templates when you choose Referral Factory. Find a template, edit, and launch. Templates can offer each user a '
                        )}
                        <a
                            target='_blank'
                            href='https://referral-factory.com/learn/how-to-create-a-referral-link-a-step-by-step-guide'
                            className='cursor-pointer underline'
                        >
                            {__('referral link')}
                        </a>
                        {__(' or a ')}
                        <a
                            target='_blank'
                            href='https://referral-factory.com/learn/what-is-a-referral-code'
                            className='cursor-pointer underline'
                        >
                            {__('referral code')}
                        </a>
                        .
                    </>
                }
                className='mx-auto mt-14 !max-w-[950px]'
            />
            <div className='flex w-full items-center justify-center'>
                <Loading />
            </div>
            <div className='hidden'>
                {RP_TEMPLATES.map((item) => {
                    return <p key={item.header}>{item.header}</p>;
                })}
                <span>{__('View all referral program templates')}</span>
                <span>{__('We’ve created over 100 templates')}</span>
            </div>
        </div>
    );
};

export default ReferralProgramsTemplatesLazy;
